import { Auth, statuses } from "@icg360/ipc-auth-js";

import * as tracking from "../units/tracking";
import { getApiUrl } from "../utils/get-api-url";

// The ipc-auth-js library can authenticate users with either:
// 1. a username/password combination
// 2. an "agentToken", which is an expiring token used as part of a SAML handshake
//    that Agency Wolf generates and passes to the user to use with Agent Portal.
// IPC Auth will validate the request and respond accordingly. It may:
// 1. respond with an Identity object and set a session cookie (IXSID), which javascript does not have access to
// 2. respond with a rejection of the request as being unauthenticated (bad password or token)
// 3. respond with a rejection of the request because the password is insecure (as determined by an external service, enzoic)
// The failure cases do not set a cookie for the user.

const trackLoginResult = (envConfig, data, success) => {
  tracking.init(envConfig.mixpanel);
  return new Promise((resolve, reject) => {
    // We need to wait until the mixpanel event is tracked before loading the app.
    // Use a two second timeout incase mixpanel takes too long.
    const timer = setTimeout(
      success ? () => resolve(data) : () => reject(data),
      2000
    );

    tracking.track(
      `ix-auth: Login ${success ? "Success" : "Failure"}`,
      data,
      () => {
        clearTimeout(timer);
        if (success) {
          resolve(data);
        } else {
          reject(data);
        }
      }
    );
  });
};

export const handleIXAuth = ({ username, password, agentToken, meta }) => {
  const client = new Auth({
    servicesUrl: getApiUrl("ixauth")
  });

  const promise = username
    ? client.login(username, password)
    : client.agentTokenLogin(agentToken);
  return promise.then(response => {
    const isSuccess = response.status === statuses.success;

    if (!isSuccess) {
      return trackLoginResult(
        // eslint-disable-next-line no-undef
        CONFIG.envConfig,
        {
          ...response,
          ...meta
        },
        false
      );
    }

    return trackLoginResult(
      // eslint-disable-next-line no-undef
      CONFIG.envConfig,
      {
        ...response,
        ...meta,
        id: response.identity.id,
        roles: Array.isArray(response.identity.roles)
          ? response.identity.roles.join()
          : ""
      },
      true
    );
  });
};
